import React from 'react';
import { MessageCircle } from 'lucide-react';
import { contactInfo } from '../mockData';

const WhatsAppButton = () => {
  const handleClick = () => {
    const message = encodeURIComponent('Merhaba, hizmetleriniz hakkında bilgi almak istiyorum.');
    window.open(`https://wa.me/${contactInfo.whatsapp}?text=${message}`, '_blank');
  };

  return (
    <div className="whatsapp-float" onClick={handleClick}>
      <MessageCircle className="w-8 h-8 text-white" />
    </div>
  );
};

export default WhatsAppButton;
